import Mock from 'mockjs';
const production_id = ['', '000-111-222-333', '000-111-222-334'];
const device_sn = ['TMAE-80', 'TMAE-90', 'TMAE-82'];
const product_sn = ['001-002-003', '001-002-004'];
const mould_sn = ['', 'G001-001', 'G001-002', 'G001-003'];
const craft_sn = ['', 'TMDC-GP-B', 'TMDC-CV-G'];
const material_sn = ['', 'ABS-BK-01', 'ABS-GY-01'];
const product_class = [''];
const emp_sn = ['', 'User01', 'User02', 'User03', 'User04', 'User05', 'User06'];
export default Mock.mock(/\/api\/product-numbers\?start=.+.&end=.+./, {
  rst: 200,
  'data|1-10': [
    {
      'product_sn|1': product_sn,
      product_name: 'Gear plate',
      'production_number|+1': 20210401,
      'product_date|+1': 20210401,
      product_count: '@integer(1, 1000)',
      MTBF: 10.11,
      MTTR: '',
      shutDown_time: '0.1',
      loss_time: '',
      'production_id|1': production_id,
      'device_sn|1': device_sn,
      'mould_sn|1': mould_sn,
      'craft_sn|1': craft_sn,
      'material_sn|1': material_sn,
      'product_class|1': product_class,
      'emp_sn|1': emp_sn,
      product_img: '',
    },
  ],
  msg: 'success',
});
